import { AxiosResponse } from 'axios';

import { api } from '../../http';
import {
  BaseFilter,
  ObjectForSelection,
  PageRequest,
  PageResponse,
  PlanningAlgorithm
} from '../../types/interfaces';

import { ApiResponse } from './interfaces';

export const PlanningAlgorithmService = {
  getAll(
    params: PageRequest & {
      sortBy?: string;
      sortDirection?: string;
      parsedFilters?: BaseFilter[];
      fillers?: string;
      filters?: string;
    }
  ): Promise<AxiosResponse<PageResponse<PlanningAlgorithm> | undefined>> {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const value = (params as Record<string, unknown>)[key];
      if (value) {
        searchParams.append(key, String(value));
      }
    });

    return api
      .get<ApiResponse<PageResponse<PlanningAlgorithm>>>('PlanningAlgorithm', {
        params: searchParams
      })
      .then((resp) => {
        if (resp.data.isSuccess) {
          return { ...resp, data: resp.data.value };
        }
        return { ...resp, data: undefined };
      });
  },

  getById(id: number): Promise<AxiosResponse<PlanningAlgorithm | undefined>> {
    return api
      .get<ApiResponse<PlanningAlgorithm>>(`PlanningAlgorithm/${id}`)
      .then((resp) => {
        const data = resp.data;
        if (
          data &&
          typeof data === 'object' &&
          'isSuccess' in data &&
          data.isSuccess
        ) {
          return { ...resp, data: data.value };
        }
        return { ...resp, data: undefined };
      });
  },

  post(
    algorithm: PlanningAlgorithm
  ): Promise<AxiosResponse<ApiResponse<PlanningAlgorithm>>> {
    return api.post<ApiResponse<PlanningAlgorithm>>(
      'PlanningAlgorithm',
      algorithm
    );
  },

  put(
    id: number,
    algorithm: PlanningAlgorithm
  ): Promise<AxiosResponse<ApiResponse<PlanningAlgorithm>>> {
    return api.put<ApiResponse<PlanningAlgorithm>>(
      `PlanningAlgorithm/${id}`,
      algorithm
    );
  },

  delete(id: number): Promise<AxiosResponse<ApiResponse<null>>> {
    return api.delete<ApiResponse<null>>(`PlanningAlgorithm/${id}`);
  },

  getForSelection(): Promise<AxiosResponse<ObjectForSelection[]>> {
    return api
      .get<ApiResponse<ObjectForSelection[]>>('PlanningAlgorithm', {
        params: { ForSelection: 'true' }
      })
      .then((resp) => {
        const items = resp.data.isSuccess ? resp.data.value ?? [] : [];
        return {
          ...resp,
          data: items.map((item) => ({
            id: item.id,
            label:
              item.label ??
              (item as ObjectForSelection & { name?: string }).name ??
              ''
          }))
        };
      });
  }
};
